import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { TopNav } from '../shared/components/navigation/TopNav';

interface OwnProps {
}

const PageWrapper = styled.div`
  padding: 20px;
`;

const PageHeader = styled.h1`
  font-size: 1.4em;
  margin-bottom: 15px;
`;

const UserPage = (props: OwnProps) => {
  const {} = props;
  const { t } = useTranslation();

  return (
    <div>
      <TopNav/>
      <PageWrapper>
        <PageHeader>{t('userPage.title')}</PageHeader>
      </PageWrapper>
    </div>
  );
};

export {
  UserPage,
};
